export default {
    data(){
        return{
            safariTrue:false
        }
    },
    methods: {
        convertDateTime(str){
            var month, day, year, hours, minutes, seconds;
            var date = new Date(str),
            month = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
            hours = ("0" + date.getHours()).slice(-2);
            minutes = ("0" + date.getMinutes()).slice(-2);
            seconds = ("0" + date.getSeconds()).slice(-2);
            var mySQLDate = [day,month,date.getFullYear()].join("-");
            var mySQLTime = [hours, minutes].join(":");
            return [mySQLDate,mySQLTime].join(" ");
        },
        convertDateTimeSlash(str){
            var month, day, year, hours, minutes, seconds;
            var date = new Date(str),
            month = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
            hours = ("0" + date.getHours()).slice(-2);
            minutes = ("0" + date.getMinutes()).slice(-2);
            seconds = ("0" + date.getSeconds()).slice(-2);
            var mySQLDate = [date.getFullYear(),month,day].join("/");
            var mySQLTime = [hours, minutes].join(":");
            return [mySQLDate,mySQLTime].join(" ");
        },
        convertDate(str){
            var month, day, year, hours, minutes, seconds;
            var date = new Date(str),
            month = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
            hours = ("0" + date.getHours()).slice(-2);
            minutes = ("0" + date.getMinutes()).slice(-2);
            seconds = ("0" + date.getSeconds()).slice(-2);
            var mySQLDate = [day,month,date.getFullYear()].join("-");
            return [mySQLDate].join(" ");
        },
        convertTime(str){
            var month, day, year, hours, minutes, seconds;
            var date = new Date(str),
            month = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
            hours = ("0" + date.getHours()).slice(-2);
            minutes = ("0" + date.getMinutes()).slice(-2);
            seconds = ("0" + date.getSeconds()).slice(-2);
            var mySQLTime = [hours, minutes].join(":");
            return [mySQLTime].join(" ");
        },
        convert(str) {
            if(!this.safariTrue){
                var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
                return [day, mnth,date.getFullYear()].join("/");
            }else{
                var date = new Date(str);
                return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
            }
        },
        dateFormat(str){
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            if(str){
                var date = new Date();
                var day = date.getDate(),
                month = monthNames[date.getMonth()];
                var mySQLDate = [day,month,date.getFullYear()].join(" ");
                return [mySQLDate].join(" ");
            }
        },
        formatDateTime(str) {
            if(!this.safariTrue){
                var date = new Date(str);
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0'+minutes : minutes;
                var strTime = hours + ':' + minutes + ' ' + ampm;
                var getmonthval = parseInt(date.getMonth())+1;
                return getmonthval + "/" +  date.getDate() + "/" + date.getFullYear() + " , " + strTime;
            }else{
                if(str != '' || str != null || str != undefined){
                    var date = str.slice(0,11).split("-"),
                    mnth = date[1],
                    day = date[2],
                    year = date[0],
                    time = str.slice(11,16);
                    var newDate = [day, mnth,year].join("/");
                    return newDate + " " + time
                    // const parts = str.split(/[- :]/);
                    // const wanted = parts[2] + '/' + parts[1] + '/' + parts[0] + ' ' + parts[3] + ':' + parts[4];
                    // return wanted;
                }
            }
        },
    },
    mounted(){
        this.safariTrue = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
}